import TablaPosicionesGroupPool from './TablaPosicionesGroupPool';
export default TablaPosicionesGroupPool;